import { apiRequest } from 'api/apiRequest'

const createDoctorSubscription = ({ paymentMethodId, cardholderName }) =>
  apiRequest('/v1/payment/subscription/doctor/create', { payment: {} }).post({
    paymentMethodId,
    cardholderName,
  })

const createPatientSubscription = ({ paymentMethodId, cardholderName }) =>
  apiRequest('/v1/payment/subscription/patient/create', { payment: {} }).post({
    paymentMethodId,
    cardholderName,
  })

const getPaymentList = () =>
  apiRequest(`/v1/payment/subscription`, { charges: {}, paymentMethod: {} }).get()

const updatePayment = ({ paymentMethodId, cardholderName, updatePayment }) =>
  apiRequest('/v1/payment/subscription/update', { payment: {} }).put({
    paymentMethodId,
    cardholderName,
    updatePayment,
  })

const getCancelStatus = () =>
  apiRequest(`/v1/payment/subscription/cancel/status`, { canceled: {} }).get()

const cancelSubscription = () =>
  apiRequest('/v1/payment/subscription/cancel', { success: {} }).put()

const reactivateSubscription = () =>
  apiRequest('/v1/payment/subscription/reactivate', { success: {} }).put()

export const paymentApi = {
  createDoctorSubscription,
  createPatientSubscription,
  getPaymentList,
  getCancelStatus,
  updatePayment,
  cancelSubscription,
  reactivateSubscription,
}
